import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=21e6b57e&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=ts&"
export * from "./app-header.vue?vue&type=script&lang=ts&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=21e6b57e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6b57e",
  null
  
)

export default component.exports